import React from 'react';

export enum radioButtonValues {
  direct = 'direct', // call me directly
  oneTime = 'oneTime', // one-time meeting
  find = 'find', // find existing meeting
  findRoom = 'findRoom', // find a room system
  none = '' // useful when we don't want to select any option.
}

export interface MeetingType {
  displayName: string;
  extension: string;
  UUID: string;
}

export interface DefaultSettings {
  meetingType: radioButtonValues;
  meetingValue: string | MeetingType;
  customMessage: string;
  includeMessage: boolean;
}

export type ContextProps = {
  canSchedule: boolean;
  creatingAppointment: boolean;
  displayAppointmentForm: () => void;
  existingMeeting: MeetingType | null;
  mailBoxSupported: boolean;
  oneTimeModerator: any;
  oneTimeName: string;
  oneTimePasscode: string;
  radioValue: radioButtonValues;
  resetForm: () => void;
  scheduleMeeting: () => void;
  scheduleMeetingError: string;
  scheduleMeetingErrorDetails: {};
  setCanSchedule: Function;
  setExistingMeeting: Function;
  setRoomSystem: Function;
  roomSystem: MeetingType | null;
  setOneTimeModerator: (moderatorObject: any) => void;
  setOneTimeName: (name: string) => void;
  setOneTimePasscode: (pin: string) => void;
  setRadioValue: (value: radioButtonValues) => void;
  setScheduleMeetingError: (error: string) => void;
};

export const MainContext = React.createContext<Partial<ContextProps>>({});
